import moment from "moment";
import { t } from "i18next";

export default class FullCalendarUtils {
    static getFormattedMonth(date) {
        const month = moment(date ? date : new Date()).month();
        const year = moment(date ? date : new Date()).year();
        let monthFormattedStr =  t(`months.${month}`);
        let formattedMonthStr = monthFormattedStr.charAt(0).toUpperCase() + monthFormattedStr.slice(1);
        return (
            <span>
                {`${year} ${formattedMonthStr}`}
            </span>
        );
    }

    static getFormattedYear(date) {
        const year = moment(date ? date : new Date()).year();
        return (
            <span>
                {`${year}`}
            </span>
        );
    }
}